"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterClearButton = exports.FilterButtons = void 0;
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Button_1 = require("../Primitives/Button");
/** Generic OK and Cancel buttons for filter popups */
const FilterButtons = ({ filterName, popupId, hasChanges = false, onOk, onCancel, onClose, disabled = false, okText, cancelText, height = 30, translationNamespace = "central-web-app-components", }) => {
    const { t } = (0, react_i18next_1.useTranslation)(translationNamespace);
    const handleOk = (evt) => {
        if (onOk) {
            onOk(evt);
        }
        if (popupId && onClose) {
            onClose(popupId);
        }
        evt.stopPropagation();
    };
    const handleCancel = (evt) => {
        if (onCancel) {
            onCancel(evt);
        }
        if (popupId && onClose) {
            onClose(popupId);
        }
        evt.stopPropagation();
    };
    return [
        react_1.default.createElement(Button_1.Button, { "data-testid": `filter-${filterName}-ok`, key: "ok", disabled: disabled || !hasChanges, onClick: handleOk, height: height }, okText || t("button-OK")),
        react_1.default.createElement(Button_1.Button, { "data-testid": `filter-${filterName}-cancel`, key: "cancel", onClick: handleCancel, height: height }, cancelText || t("button-Cancel")),
    ];
};
exports.FilterButtons = FilterButtons;
/** Generic Clear button for filter popups */
const FilterClearButton = ({ filterName, onClear, isCleared = false, clearText, resetText, useResetText = false, height = 30, translationNamespace = "central-web-app-components", }) => {
    const { t } = (0, react_i18next_1.useTranslation)(translationNamespace);
    const handleClear = (evt) => {
        if (onClear) {
            onClear(evt);
        }
        evt.stopPropagation();
    };
    const buttonText = useResetText
        ? resetText || t("button-Reset")
        : clearText || t("button-Clear");
    return (react_1.default.createElement(Button_1.Button, { "data-testid": `filter-${filterName}-clear`, key: "clear", disabled: isCleared, onClick: handleClear, height: height }, buttonText));
};
exports.FilterClearButton = FilterClearButton;
//# sourceMappingURL=Buttons.js.map